/* eslint-disable @typescript-eslint/naming-convention */
export enum imageMetadataTypesApiEnum {
    logo = 'LOGO',
    label = 'LABEL',
    webEntity = 'WEB_ENTITY'
}
